import React, { useEffect, useRef } from 'react';
import './TopAnnouncementBar.css';
import { FaRocket, FaChartLine, FaRobot, FaCheckCircle, FaStar, FaArrowRight } from 'react-icons/fa';
import { GiStarsStack, GiRocketThruster } from 'react-icons/gi';

const TopAnnouncementBar = () => {
  const scrollRef = useRef(null);

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (scrollContainer) {
      const scrollWidth = scrollContainer.scrollWidth;
      const animationDuration = (scrollWidth / 50) + 15;
      scrollContainer.style.animationDuration = `${animationDuration}s`;
    }
  }, []);

  const announcement = "On aide les entreprises à passer d'un business chaotique à un business structuré — avec des process clairs, des informations centralisées et des tâches qui tournent toutes seules.";

  return (
    <div className="ta-announcement-bar">
      <div className="ta-announcement-container">
        <div className="ta-announcement-icon">
          <GiRocketThruster />
        </div>
        <div className="ta-announcement-content">
          <div className="ta-announcement-text" ref={scrollRef}>
            <span className="ta-text-with-icon">
              <FaRocket className="ta-text-icon" />
              {announcement}
              <FaArrowRight className="ta-arrow-icon" />
            </span>
            <span className="ta-text-with-icon">
              <FaRobot className="ta-text-icon" />
              {announcement}
              <FaArrowRight className="ta-arrow-icon" />
            </span>
            <span className="ta-text-with-icon">
              <FaChartLine className="ta-text-icon" />
              {announcement}
              <FaArrowRight className="ta-arrow-icon" />
            </span>
          </div>
        </div>
        <div className="ta-announcement-badge">
          <FaStar />
          <span>Nouveau</span>
          <GiStarsStack />
        </div>
      </div>
    </div>
  );
};

export default TopAnnouncementBar;